import { RankWrapper, TopicWrapper, TopicContainer } from './EsgTopicTitleStyles';
import { useSelector } from 'react-redux';

const EsgTopicTitle = ({ topic, rank }) => {
  const language = useSelector((state) => state.user.language);

  return (
    <TopicContainer>
      <RankWrapper>
        <div className="text-primary-500">{rank}</div>
      </RankWrapper>
      <TopicWrapper>
        <div className="text-text-500">{topic[`topic_name_${language}`]}</div>
      </TopicWrapper>
    </TopicContainer>
  );
};

export default EsgTopicTitle;
